import { useState, useContext } from 'react';
import { Link, withRouter } from 'react-router-dom';
import styles from './DirectoryList.module.scss';
import { AppContext } from '../../context/AppContext';
import { getCategoriesToMap } from '../../lib/util';
import { IAppContext } from '../../context/DefaultAppState';
import _ from 'lodash';

export enum DirectoryListType {
  doctor = 'doctor',
  pharmacy = 'pharmacy',
  dentist = 'dentist',
  facility = 'hospital, facility, or other service',
  hearingAid = 'hearing aids',
  transportation = 'transportation',
  all = 'all',
  phone = 'phone',
  none = ''
}

const DirectoryList = () => {
  const appContext = useContext(AppContext);
  const { isDirectorySelected, directoryListType } = appContext;
  const [isShowingMore, setIsShowingMore] = useState(true);

  const setCategories = (shouldShowMore: boolean, appContext: IAppContext, isNotDropDown?: boolean, additionalTabSpecialties?: string[]): string[] => {
    if (appContext.directoryListType === DirectoryListType.facility) {
      const additionalTabSpecialties = [
        'Hearing Aids',
        'Transportation'
      ];
      return _.sortBy(getCategoriesToMap(isShowingMore, appContext, true).concat(additionalTabSpecialties), (x: any) => x.toLowerCase())
    }
    else {
      return getCategoriesToMap(isShowingMore, appContext, true)
    }
  }

  const setCategoryLinks = (shouldShowMore: boolean, appContext: IAppContext, isNotDropDown?: boolean) => {
    const additionalTabSpecialties = [
      'Hearing Aids',
      'Transportation'
    ];
    const links = setCategories(isShowingMore, appContext, true, additionalTabSpecialties).map((specialty) => (
      <div key={`dli-${specialty}`}>
        {!additionalTabSpecialties.includes(specialty) ? <Link
          className={styles.listItemLink}
          onClick={() => appContext.updateChosenSpecialty(specialty)}
          to={appContext.planState ? `/results/${appContext.planCode}/${appContext.directoryListType}/${specialty}` : `/state-selection`}
        >
          {specialty}
        </Link> :
        <Link
        className={styles.listItemLink}
        onClick={() => goToNewTab(specialty)}
        to='/'
      >
        {specialty}
      </Link>}
      </div>
    ));

    return links
  }

  const goToNewTab = (specialty: string) => {
    // <DirectoryCard title="Hearing Aids" currentListType={currentListType} listType={DirectoryListType.hearingAid}>
    // <DirectoryCard title="Transportation" currentListType={currentListType} listType={DirectoryListType.transportation}></DirectoryCard>
    console.log(specialty);
    switch (specialty) {
      case 'Hearing Aids':
        appContext.updateListType(DirectoryListType.hearingAid);
        break;
      case 'Transportation':
        appContext.updateListType(DirectoryListType.transportation);
        break;
      default:
        break;
    }
  }

  return (
    <>
      {isDirectorySelected && directoryListType !== DirectoryListType.none && directoryListType !== DirectoryListType.phone && directoryListType !== DirectoryListType.hearingAid && directoryListType !== DirectoryListType.transportation && directoryListType !== DirectoryListType.all ? (
        <>
          <h3 className={styles.listMessage}>What kind of {directoryListType} are you looking for?</h3>
          <div className={styles.listContainer}>
            {setCategoryLinks(isShowingMore, appContext, true)}
          </div>
          {/* {getCategoriesToMap(isShowingMore, appContext, true).length > 1 ? (
            <div className={styles.showMessageToggle} onClick={() => setIsShowingMore(!isShowingMore)}>
              {showMessage}
            </div>
          ) : null} */}
        </>
      ) : null}
    </>
  );
};

export default withRouter(DirectoryList);
